var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import Inset from '../../spacing/Inset';
import modalKeyboardHandler from '../../../helpers/modalKeyboardHandler';
import { colors, opacities } from '../../../defaultTheme';
import query from '../../../const/mediaQueries';
const Container = styled.div `
  position: fixed;
  top: 25%;
  overflow: auto;
  z-index: 2;
  left: 50%;
  transform: translate(-50%, -60%);
  background-color: ${colors.white};
  opacity: 0;
  max-height: 85vh;
  border-radius: 10px;
  box-shadow: 0 4px 5px 0 ${opacities.rgbaLight10},
    0 3px 14px 3px ${opacities.rgbaLight08},
    0 8px 10px 1px ${opacities.rgbaLight04};
  display: flex;
  flex-direction: column;
  transition-property: opacity, transform;
  transition-duration: ${(props) => `${props.transitionDuration}ms`},
    ${(props) => `${props.transitionDuration}ms`}, 0s;
  transition-timing-function: linear, ease-in-out;
  width: 95%;
  margin: auto;

  @media ${query.greaterThanMedium} {
    width: auto;
    min-width: 450px;
  }
`;
// darkened overlay styles - need to use pseudo element
export const Overlay = styled.div `
  ${({ isOpen }) => isOpen &&
    `
    :after {
      content: "";
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      background-color: ${opacities.rgbaHalfOpacity};
    }
  `}
`;
export const StyledFooter = styled(Inset) `
  padding: 12px 32px 0px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
    justify-content: ${(props) => props.$shouldAlignCenter ? 'center' : 'flex-end'};

    button {
      margin-bottom: 0;
      margin-left: 8px;
    }
  }
`;
export const ModalWrapper = (_a) => {
    var { children, className, escapeModalHandler, id, modalRef, transitionDuration } = _a, props = __rest(_a, ["children", "className", "escapeModalHandler", "id", "modalRef", "transitionDuration"]);
    const keyListener = (e) => modalKeyboardHandler(e, { escapeHandler: escapeModalHandler });
    useEffect(() => {
        document.addEventListener('keydown', keyListener);
        return () => document.removeEventListener('keydown', keyListener);
    });
    return (_jsx(Container, Object.assign({ id: id, role: "dialog", className: className, transitionDuration: transitionDuration, ref: modalRef }, props, { children: children })));
};
